export const STATUS_OPTIONS = [
  { value: "new",       label: "New",       short: "New",      dot: "bg-blue-500",   chip: "bg-blue-500/10 text-blue-700 border-blue-500/30" },
  { value: "in_review", label: "In Review", short: "Review",   dot: "bg-amber-500",  chip: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  { value: "replied",   label: "Replied",   short: "Replied",  dot: "bg-emerald-500",chip: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  { value: "closed",    label: "Closed",    short: "Closed",   dot: "bg-zinc-400",   chip: "bg-zinc-400/10 text-zinc-600 border-zinc-300" },
];

export const statusMeta = (s) => STATUS_OPTIONS.find((o) => o.value === s) || STATUS_OPTIONS[0];
